module.exports = __webpack_public_path__ + "static/media/comment-alt-medical.fb7821a7.svg";